import { useRef, useEffect, useCallback } from 'react'

interface UseInfiniteScrollOptions {
  hasMore: boolean
  isLoading: boolean
  onLoadMore: () => void
  threshold?: number
  enabled?: boolean
}

export function useInfiniteScroll({
  hasMore,
  isLoading,
  onLoadMore,
  threshold = 0.1,
  enabled = true,
}: UseInfiniteScrollOptions) {
  const sentinelRef = useRef<HTMLDivElement>(null)

  const handleIntersect = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      if (entries[0].isIntersecting && hasMore && !isLoading && enabled) {
        onLoadMore()
      }
    },
    [hasMore, isLoading, enabled, onLoadMore]
  )

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersect, { threshold })

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current)
    }

    return () => observer.disconnect()
  }, [handleIntersect, threshold])

  return { sentinelRef }
}
